(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elemental-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const ELEMENTAL_WINES_PATH = 'pages/elemental-wine#wines';
    let cartFrame = null;

    const isElementalCart = () =>
      document.body.matches('body.template-elemental[data-elemental-template="cart"]');

    const elementalWinesUrl = () => {
      const root = window.Shopify?.routes?.root || '/';
      return `${root.endsWith('/') ? root : `${root}/`}${ELEMENTAL_WINES_PATH}`;
    };

    const closeDialog = (dialog) => {
      if (!(dialog instanceof HTMLDialogElement)) return;
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
    };

    const initialisePolicyDialogs = (footer) => {
      if (!(footer instanceof HTMLElement) || footer.dataset.elementalPolicyReady === 'true') return;
      footer.dataset.elementalPolicyReady = 'true';
      let lastTrigger = null;

      footer.querySelectorAll('[data-elemental-policy-open]').forEach((button) => {
        button.addEventListener('click', () => {
          const id = button.getAttribute('data-elemental-policy-open');
          const dialog = id ? document.getElementById(id) : null;
          if (!(dialog instanceof HTMLDialogElement)) return;

          footer.querySelectorAll('[data-elemental-policy-dialog][open]').forEach((openDialog) => {
            if (openDialog !== dialog) closeDialog(openDialog);
          });

          lastTrigger = button;
          document.body.classList.add('elemental-policy-open');
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        });
      });

      footer.querySelectorAll('[data-elemental-policy-dialog]').forEach((dialog) => {
        dialog.querySelectorAll('[data-elemental-policy-close]').forEach((button) => {
          button.addEventListener('click', () => closeDialog(dialog));
        });

        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
          if (outside) closeDialog(dialog);
        });

        dialog.addEventListener('close', () => {
          document.body.classList.remove('elemental-policy-open');
          if (lastTrigger instanceof HTMLElement) lastTrigger.focus();
          lastTrigger = null;
        });
      });
    };

    const patchElementalCartRequests = () => {
      if (!isElementalCart() || window.__elementalCartFetchPatched) return;
      const nativeFetch = window.fetch.bind(window);

      window.fetch = (input, init) => {
        let nextInit = init;

        if (isElementalCart() && init && typeof init.body === 'string') {
          try {
            const payload = JSON.parse(init.body);
            if (payload && typeof payload.sections_url === 'string') {
              const sectionsUrl = new URL(payload.sections_url, window.location.origin);
              sectionsUrl.searchParams.set('view', 'elemental');
              payload.sections_url = `${sectionsUrl.pathname}${sectionsUrl.search}`;
              nextInit = { ...init, body: JSON.stringify(payload) };
            }
          } catch (error) {
            /* Non-JSON requests pass through untouched. */
          }
        }

        return nativeFetch(input, nextInit);
      };

      window.__elementalCartFetchPatched = true;
    };

    const applyElementalCartState = () => {
      if (!isElementalCart()) return;

      const destination = elementalWinesUrl();
      document.querySelectorAll('a[data-wc-cart-continue], a.cart-items__empty-button').forEach((link) => {
        if (link.getAttribute('href') !== destination) link.setAttribute('href', destination);
      });

      document.querySelectorAll('[data-wc-cart-guidance]').forEach((message) => {
        message.classList.remove('is-invalid');
        message.classList.add('is-valid');
        let heading = message.querySelector('strong');
        if (!heading) {
          heading = document.createElement('strong');
          message.prepend(heading);
        }
        const copy = 'Your Elemental order is ready for checkout.';
        if (heading.textContent !== copy) heading.textContent = copy;
      });

      const footer = document.querySelector('[data-elemental-footer]');
      const taxLead = footer?.dataset.elementalTaxMessage || 'Taxes and duties are handled at checkout.';
      const taxCopy = `${taxLead} Elemental wines are sold in complete 6- or 12-bottle packs; the three-bottle shipping rule does not apply.`;
      document.querySelectorAll('.cart-totals__tax-note small').forEach((note) => {
        if (note.textContent.trim() !== taxCopy) note.textContent = taxCopy;
      });

      if (document.querySelector('.cart-form')) {
        document.querySelectorAll('#checkout, .cart__checkout-button').forEach((button) => {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
          button.removeAttribute('title');
        });

        document.querySelectorAll('.additional-checkout-buttons').forEach((buttons) => {
          buttons.classList.remove('wc-is-disabled');
          buttons.setAttribute('aria-hidden', 'false');
        });
      }
    };

    const scheduleElementalCartState = () => {
      if (cartFrame) window.cancelAnimationFrame(cartFrame);
      cartFrame = window.requestAnimationFrame(() => {
        cartFrame = null;
        applyElementalCartState();
      });
    };

    const initialise = (root = document) => {
      root.querySelectorAll?.('[data-elemental-footer]').forEach(initialisePolicyDialogs);
      patchElementalCartRequests();
      scheduleElementalCartState();

      if (isElementalCart() && !window.__elementalCartObserver) {
        const main = document.getElementById('MainContent');
        if (main) {
          const observer = new MutationObserver(scheduleElementalCartState);
          observer.observe(main, { childList: true, subtree: true });
          window.__elementalCartObserver = observer;
        }
      }

      window.setTimeout(applyElementalCartState, 120);
      window.setTimeout(applyElementalCartState, 500);
    };

    document.addEventListener('cart:update', scheduleElementalCartState);
    window.addEventListener('pageshow', scheduleElementalCartState);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target || document));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
    } else {
      initialise(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
